/*
 *
 * PushNotifications reducer
 *
 */
import produce from 'immer';
import * as actionTypes from '@project/store/pushNotifications/constants';
export var initialState = {
    pushNotifications: false,
    pushNotificationsAppId: '',
    meta: {},
    pushNotifications_loading: false,
    pushNotifications_error: false,
    deletePushNotification_request: false,
    deletePushNotification_error: false,
    sendPushNotification_request: false,
    sendPushNotification_error: false,
    testPushNotification_request: false,
    testPushNotification_error: false,
    currentPushNotification: false,
    pushNotificationData_loading: false,
    pushNotificationData_error: false,
    message: '',
    selectedDatasetId: '',
    files: [],
    filesMeta: {},
    folders: [],
    foldersMeta: {},
    groups: [],
    groupsMeta: {},
    users: [],
    usersMeta: {},
};
function pushNotificationsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case actionTypes.LOAD_PUSH_NOTIFICATIONS_REQUEST:
                state.pushNotifications_loading = true;
                state.pushNotifications_error = false;
                break;
            case actionTypes.CLEAR_PUSH_NOTIFICATIONS_SUCCESS:
                state.pushNotifications = false;
                state.meta = {};
                state.pushNotificationsAppId = action.appId;
                break;
            case actionTypes.LOAD_PUSH_NOTIFICATIONS_SUCCESS:
                state.pushNotifications = action.pushNotifications;
                state.meta = action.meta;
                state.pushNotifications_loading = false;
                state.pushNotifications_error = false;
                break;
            case actionTypes.LOAD_PUSH_NOTIFICATIONS_FAILURE:
                state.pushNotifications_loading = false;
                state.pushNotifications_error = true;
                break;
            case actionTypes.LOAD_PUSH_NOTIFICATION_DATA_REQUEST:
                state.pushNotificationData_loading = false;
                state.pushNotificationData_error = true;
                break;
            case actionTypes.LOAD_PUSH_NOTIFICATION_DATA_SUCCESS:
                state.currentPushNotification = action.currentPushNotification;
                state.pushNotificationData_loading = false;
                state.pushNotificationData_error = false;
                break;
            case actionTypes.LOAD_PUSH_NOTIFICATION_DATA_FAILURE:
                state.pushNotificationData_loading = false;
                state.pushNotificationData_error = true;
                break;
            case actionTypes.SEND_PUSH_NOTIFICATION_REQUEST:
                state.sendPushNotification_request = true;
                state.sendPushNotification_error = false;
                break;
            case actionTypes.SEND_PUSH_NOTIFICATION_SUCCESS:
                state.sendPushNotification_request = false;
                state.sendPushNotification_error = false;
                break;
            case actionTypes.SEND_PUSH_NOTIFICATION_FAILURE:
                state.sendPushNotification_request = false;
                state.sendPushNotification_error = true;
                break;
            case actionTypes.TEST_PUSH_NOTIFICATION_REQUEST:
                state.testPushNotification_request = true;
                state.testPushNotification_error = false;
                break;
            case actionTypes.TEST_PUSH_NOTIFICATION_SUCCESS:
                state.testPushNotification_request = false;
                state.testPushNotification_error = false;
                break;
            case actionTypes.TEST_PUSH_NOTIFICATION_FAILURE:
                state.testPushNotification_request = false;
                state.testPushNotification_error = true;
                break;
            case actionTypes.DELETE_PUSH_NOTIFICATION_REQUEST:
                state.deletePushNotification_request = true;
                state.deletePushNotification_error = false;
                break;
            case actionTypes.DELETE_PUSH_NOTIFICATION_SUCCESS:
                state.deletePushNotification_request = false;
                state.deletePushNotification_error = false;
                break;
            case actionTypes.DELETE_PUSH_NOTIFICATION_FAILURE:
                state.deletePushNotification_request = false;
                state.deletePushNotification_error = true;
                break;
            case actionTypes.CHANGE_MESSAGE:
                state.message = action.message;
                break;
            case actionTypes.LOAD_FILES_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case actionTypes.LOAD_FILES_SUCCESS:
                state.files = action.files;
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case actionTypes.LOAD_FILES_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case actionTypes.LOAD_GROUPS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case actionTypes.LOAD_GROUPS_SUCCESS:
                state.groups = action.groups;
                state.groupsMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case actionTypes.LOAD_GROUPS_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case actionTypes.LOAD_USERS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case actionTypes.LOAD_USERS_SUCCESS:
                state.users = action.users;
                state.usersMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case actionTypes.LOAD_USERS_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case actionTypes.ARCHIVE_PUSH_NOTIFICATION_REQUEST:
                state.pushNotifications_loading = true;
                state.pushNotifications_error = false;
                break;
            case actionTypes.ARCHIVE_PUSH_NOTIFICATION_SUCCESS:
                state.pushNotifications_loading = false;
                state.pushNotifications_error = false;
                break;
            case actionTypes.ARCHIVE_PUSH_NOTIFICATION_FAILURE:
                state.pushNotifications_loading = false;
                state.pushNotifications_error = true;
                break;
            default:
                break;
        }
    });
}
export default pushNotificationsReducer;
